import { of, timer } from 'rxjs';
import { map, mapTo, switchMap } from 'rxjs/operators';

import { redirect } from '@/common/utils';
import { Guard, logoutReason, rootRoutePaths, rootRoutes } from '@/core/navigation';
import { clearCookies, getLoginPageUrl, getResetPasswordPageUrl, getUserTokens, login, triggerLocalStorageLoginEvent } from '@/core/services/authentication';

const ACCOUNT_HUB_ERROR = {
  resetPasswordRedirection: 'AADB2C90118',
  exceededMaximumNumberForRetriesForSignup: 'AADB2C90157',
  cancelledProcess: 'AADB2C90091',
};

const WAIT_TIME = 5000;

export type VerifyProps = {
  reason: logoutReason;
};

export const verifyGuard: Guard<VerifyProps> = (params) => {
  const queryParams = new URLSearchParams(params.location.search);
  const code = queryParams.get('code');
  const error = queryParams.get('error');
  const errorDescription = queryParams.get('error_description');
  if (code) {
    return getUserTokens(code).pipe(
      switchMap((data) => {
        if (data === undefined) {
          clearCookies();
          return of({ guardProps: { reason: logoutReason.TOKEN } });
        }

        return login({ store: params.store, preventRedirect: true }).pipe(
          map((loginData) => {
            if (loginData === undefined) {
              clearCookies();
              return { guardProps: { reason: logoutReason.USER_PROFILE } };
            }

            triggerLocalStorageLoginEvent();
            return { redirectUrl: rootRoutePaths[rootRoutes.AUTHENTICATED] };
          })
        );
      })
    );
  }

  if (error && errorDescription) {
    const errorCode = /^[^:]*/.exec(errorDescription);
    if (errorCode) {
      switch (errorCode[0]) {
        case ACCOUNT_HUB_ERROR.resetPasswordRedirection: {
          redirect(getResetPasswordPageUrl());
          return timer(WAIT_TIME).pipe(mapTo({ guardProps: { reason: logoutReason.COMMON_ERROR } }));
        }

        case ACCOUNT_HUB_ERROR.exceededMaximumNumberForRetriesForSignup:
        case ACCOUNT_HUB_ERROR.cancelledProcess: {
          redirect(getLoginPageUrl());
          return timer(WAIT_TIME).pipe(mapTo({ guardProps: { reason: logoutReason.COMMON_ERROR } }));
        }

        default: {
        }
      }
    }
  }

  return of({ guardProps: { reason: logoutReason.COMMON_ERROR } });
};
